import React, { useState, useRef } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Link,
  IconButton,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import useHeaderScroll from "../hooks/useHeaderScroll";

const NavigationMenu = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  const headerRef = useRef(null);
  const handleClick = useHeaderScroll(headerRef);

  const NavLink = ({ children, href, onClick }) => (
    <Link
      href={href}
      onClick={onClick}
      px="16px"
      py="8px"
      _hover={{
        textDecoration: "underline",
        textDecorationColor: "white",
        textUnderlineOffset: "4px",
        textDecorationThickness: "2px"
      }}
      fontWeight="700"
      fontSize="14px"
      fontFamily="'Inter', sans-serif"
    >
      {children}
    </Link>
  );

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={1}
      transitionProperty="transform"
      transitionDuration=".3s"
      transitionTimingFunction="ease-in-out"
      backgroundColor="#0F4C5C"
      boxShadow="0px 2px 6px rgba(0, 0, 0, 0.25)"
      ref={headerRef}
    >
      <Flex
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        maxWidth={{ md: "900px", lg: "1280px" }}
        // maxWidth="1280px"
        margin="0 auto"
      >
        <Text
          color="#FAFAFA"
          fontFamily="'Source Serif Pro', serif"
          fontSize="32px"
          fontWeight="400"
          lineHeight="1.4"
          my="auto"
          pl="32px"
        >
          Xola dos Santos
        </Text>

        {/* Desktop Navigation */}
        <Flex
          display={{ base: "none", md: "flex" }}
          backgroundColor="navyBlue.500"
          minHeight="80px"
          px="20px"
          py="22px"
          alignItems="center"
          gap={{ base: "20px", lg: "40px" }}
          fontFamily="'Source Serif 4 18pt', serif"
          fontSize="14px"
          fontWeight="700"
          justifyContent="space-between"
        >
          <HStack spacing={4} color="#FFF">
            {/* <NavLink href="/#home" onClick={handleClick("home")}>
              Home
            </NavLink>
            <NavLink href="/#blog" onClick={handleClick("blog")}>
              Blog
            </NavLink>
            <NavLink href="/#about" onClick={handleClick("about")}>
              About
            </NavLink> */}
            <NavLink
              href="/downloads/Xola_dos_Santos_Brief_Re_sume_.pdf"
              target="_blank"
              rel="noopener noreferrer"
              // onClick={() => {
              //   handleClick("social");
              // }}
            >
              Download Resumé PDF
            </NavLink>
          </HStack>

          {/* <Button
            borderRadius="3px"
            backgroundColor="#FFF"
            color="navyBlue.500"
            px="16px"
            py="8px"
            fontWeight="700"
            _hover={{
              backgroundColor: "rgba(250, 250, 250, 0.9)",
              transform: "translateY(-2px)",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
            transition="all 0.3s ease"
          >
            Let's Talk
          </Button> */}
        </Flex>

        {/* Mobile Navigation Icon */}
        <IconButton
          ref={btnRef}
          display={{ base: "flex", md: "none" }}
          aria-label="Open menu"
          fontSize="20px"
          variant="ghost"
          color="white"
          icon={<FontAwesomeIcon icon={faBars} />}
          onClick={onOpen}
          mr={4}
        />

        {/* Mobile Navigation Drawer */}
        <Drawer
          isOpen={isOpen}
          placement="right"
          onClose={onClose}
          finalFocusRef={btnRef}
          size="full"
          color="#1A202C"
        >
          <DrawerOverlay />
          <DrawerContent backgroundColor="navyBlue.500">
            <DrawerCloseButton color="#1A202C" />
            <DrawerHeader
              color="#1A202C"
              fontFamily="'Source Serif Pro', serif"
            >
              Xola dos Santos
            </DrawerHeader>

            <DrawerBody>
              <VStack spacing={8} align="center" mt={10} color="#1A202C">
                {/* <NavLink
                  href="/#home"
                  onClick={() => {
                    onClose();
                    handleClick("home")();
                  }}
                >
                  Home
                </NavLink>
                <NavLink
                  href="/#blog"
                  onClick={() => {
                    onClose();
                    handleClick("blog")();
                  }}
                >
                  Blog
                </NavLink>
                <NavLink
                  href="/#about"
                  onClick={() => {
                    onClose();
                    handleClick("about")();
                  }}
                >
                  About
                </NavLink> */}
                <NavLink
                  href="/downloads/Xola_dos_Santos_Brief_Re_sume_.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  // onClick={() => {
                  //   onClose();
                  //   handleClick("social")();
                  // }}
                >
                  Download Resumé PDF
                </NavLink>
                {/* <Button
                  borderRadius="3px"
                  backgroundColor="#FFF"
                  color="navyBlue.500"
                  px="16px"
                  py="8px"
                  fontWeight="700"
                  _hover={{
                    backgroundColor: "rgba(250, 250, 250, 0.9)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                  transition="all 0.3s ease"
                  onClick={onClose}
                >
                  Let's Talk
                </Button> */}
              </VStack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Flex>
    </Box>
  );
};

export default NavigationMenu;
